import { WeatherState } from "./types";

export const testWeatherState: WeatherState = {
  state: "success",
  error: null,
  nowWeather: {
    tmp: 24.5,
    sky: "sunny",
    reh: "67",
    wind: {
      vec: "east",
      wsd: "1.3",
    },
    pm10Grade: "good",
    pm25Grade: "common",
  },
  tomorrowWeather: {
    pm10Grade: "common",
    pm25Grade: "common",
    am: {
      pop: 22,
      sky: "cloudy",
    },
    pm: {
      pop: 15,
      sky: "cloudy",
    },
    tmn: 22,
    tmx: 29,
  },
  threeDay: [
    {
      date: "20230911",
      hourly: [
        {
          date: "20230911",
          hour: "2200",
          sky: "sunny",
          temp: 24,
          pop: "0",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.8",
          },
          reh: "70",
        },
        {
          date: "20230911",
          hour: "2300",
          sky: "cloudy",
          temp: 24,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "sse",
            wsd: "0.7",
          },
          reh: "75",
        },
      ],
    },
    {
      date: "20230912",
      hourly: [
        {
          date: "20230912",
          hour: "0000",
          sky: "cloudy",
          temp: 24,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.8",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "0100",
          sky: "cloudy",
          temp: 23,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.8",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "0200",
          sky: "cloudy",
          temp: 23,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.5",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "0300",
          sky: "cloudy",
          temp: 23,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.3",
          },
          reh: "80",
        },
        {
          date: "20230912",
          hour: "0400",
          sky: "cloudy",
          temp: 22,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.3",
          },
          reh: "80",
        },
        {
          date: "20230912",
          hour: "0500",
          sky: "cloudy",
          temp: 22,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "0.4",
          },
          reh: "85",
        },
        {
          date: "20230912",
          hour: "0600",
          sky: "cloudy",
          temp: 22,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "0.6",
          },
          reh: "85",
        },
        {
          date: "20230912",
          hour: "0700",
          sky: "cloudy",
          temp: 22,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "0.3",
          },
          reh: "85",
        },
        {
          date: "20230912",
          hour: "0800",
          sky: "cloudy",
          temp: 23,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "sse",
            wsd: "0.2",
          },
          reh: "80",
        },
        {
          date: "20230912",
          hour: "0900",
          sky: "veryCloudy",
          temp: 24,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "0.4",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "1000",
          sky: "veryCloudy",
          temp: 25,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "0.9",
          },
          reh: "70",
        },
        {
          date: "20230912",
          hour: "1100",
          sky: "cloudy",
          temp: 26,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.3",
          },
          reh: "65",
        },
        {
          date: "20230912",
          hour: "1200",
          sky: "cloudy",
          temp: 27,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.7",
          },
          reh: "60",
        },
        {
          date: "20230912",
          hour: "1300",
          sky: "cloudy",
          temp: 28,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.7",
          },
          reh: "55",
        },
        {
          date: "20230912",
          hour: "1400",
          sky: "cloudy",
          temp: 28,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.8",
          },
          reh: "55",
        },
        {
          date: "20230912",
          hour: "1500",
          sky: "cloudy",
          temp: 29,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "sse",
            wsd: "1.8",
          },
          reh: "55",
        },
        {
          date: "20230912",
          hour: "1600",
          sky: "cloudy",
          temp: 28,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.8",
          },
          reh: "55",
        },
        {
          date: "20230912",
          hour: "1700",
          sky: "sunny",
          temp: 28,
          pop: "0",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "1.8",
          },
          reh: "60",
        },
        {
          date: "20230912",
          hour: "1800",
          sky: "sunny",
          temp: 27,
          pop: "0",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "2.1",
          },
          reh: "65",
        },
        {
          date: "20230912",
          hour: "1900",
          sky: "sunny",
          temp: 25,
          pop: "0",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "1.7",
          },
          reh: "70",
        },
        {
          date: "20230912",
          hour: "2000",
          sky: "cloudy",
          temp: 25,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "1.3",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "2100",
          sky: "cloudy",
          temp: 25,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ese",
            wsd: "1.2",
          },
          reh: "75",
        },
        {
          date: "20230912",
          hour: "2200",
          sky: "cloudy",
          temp: 25,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.8",
          },
          reh: "80",
        },
        {
          date: "20230912",
          hour: "2300",
          sky: "cloudy",
          temp: 24,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "se",
            wsd: "0.7",
          },
          reh: "80",
        },
      ],
    },
    {
      date: "20230913",
      hourly: [
        {
          date: "20230913",
          hour: "0000",
          sky: "cloudy",
          temp: 24,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "sse",
            wsd: "0.6",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "0100",
          sky: "cloudy",
          temp: 24,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "0.4",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "0200",
          sky: "cloudy",
          temp: 23,
          pop: "20",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.4",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0300",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.8",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0400",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.8",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0500",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ene",
            wsd: "1",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0600",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "0.7",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0700",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.8",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0800",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.8",
          },
          reh: "85",
        },
        {
          date: "20230913",
          hour: "0900",
          sky: "veryCloudy",
          temp: 24,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.9",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "1000",
          sky: "veryCloudy",
          temp: 25,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ene",
            wsd: "1.1",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "1100",
          sky: "veryCloudy",
          temp: 25,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "east",
            wsd: "0.7",
          },
          reh: "75",
        },
        {
          date: "20230913",
          hour: "1200",
          sky: "veryCloudy",
          temp: 26,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "0.8",
          },
          reh: "75",
        },
        {
          date: "20230913",
          hour: "1300",
          sky: "veryCloudy",
          temp: 26,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "ne",
            wsd: "1.7",
          },
          reh: "70",
        },
        {
          date: "20230913",
          hour: "1400",
          sky: "veryCloudy",
          temp: 27,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.9",
          },
          reh: "65",
        },
        {
          date: "20230913",
          hour: "1500",
          sky: "veryCloudy",
          temp: 26,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "2.3",
          },
          reh: "65",
        },
        {
          date: "20230913",
          hour: "1600",
          sky: "veryCloudy",
          temp: 26,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "2.3",
          },
          reh: "70",
        },
        {
          date: "20230913",
          hour: "1700",
          sky: "veryCloudy",
          temp: 25,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "2",
          },
          reh: "75",
        },
        {
          date: "20230913",
          hour: "1800",
          sky: "veryCloudy",
          temp: 25,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.6",
          },
          reh: "75",
        },
        {
          date: "20230913",
          hour: "1900",
          sky: "veryCloudy",
          temp: 24,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.4",
          },
          reh: "75",
        },
        {
          date: "20230913",
          hour: "2000",
          sky: "veryCloudy",
          temp: 24,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.4",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "2100",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.3",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "2200",
          sky: "veryCloudy",
          temp: 23,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.1",
          },
          reh: "80",
        },
        {
          date: "20230913",
          hour: "2300",
          sky: "veryCloudy",
          temp: 22,
          pop: "30",
          pcp: "강수없음",
          sno: "적설없음",
          wind: {
            vec: "nne",
            wsd: "1.4",
          },
          reh: "80",
        },
      ],
    },
  ],
  week: [
    {
      daysLater: 0,
      am: {
        pop: 28,
        sky: "veryCloudy",
      },
      pm: {
        pop: 13,
        sky: "sunny",
      },
      tmn: 22,
      tmx: 29,
    },
    {
      daysLater: 1,
      am: {
        pop: 22,
        sky: "cloudy",
      },
      pm: {
        pop: 15,
        sky: "cloudy",
      },
      tmn: 22,
      tmx: 29,
    },
    {
      daysLater: 2,
      am: {
        pop: 27,
        sky: "veryCloudy",
      },
      pm: {
        pop: 30,
        sky: "veryCloudy",
      },
      tmn: 22,
      tmx: 29,
    },
    {
      daysLater: 3,
      am: {
        pop: 40,
        sky: "veryCloudy",
      },
      pm: {
        pop: 30,
        sky: "cloudy",
      },
      tmn: 21,
      tmx: 28,
    },
    {
      daysLater: 4,
      am: {
        pop: 60,
        sky: "vrCldRain",
      },
      pm: {
        pop: 80,
        sky: "vrCldRain",
      },
      tmn: 21,
      tmx: 26,
    },
    {
      daysLater: 5,
      am: {
        pop: 90,
        sky: "vrCldRain",
      },
      pm: {
        pop: 40,
        sky: "veryCloudy",
      },
      tmn: 22,
      tmx: 27,
    },
    {
      daysLater: 6,
      am: {
        pop: 40,
        sky: "veryCloudy",
      },
      pm: {
        pop: 40,
        sky: "cloudy",
      },
      tmn: 22,
      tmx: 29,
    },
  ],
  nation: null,
  sunRiseAndSet: [
    {
      date: "0911",
      sunRise: "06:10",
      sunSet: "18:47",
    },
    {
      date: "0912",
      sunRise: "06:11",
      sunSet: "18:46",
    },
    {
      date: "0913",
      sunRise: "06:11",
      sunSet: "18:44",
    },
  ],
};
